import React, {Component, Fragment} from 'react';

export default class Home extends Component {
    render() {
        return (
            <Fragment>
                <div className="main">
                    <div className="offset-sm-2 col-sm-8 mt-4 p-4" style={{background: 'white'}}>

                        <h2>Küpsised</h2>
                        <p>
                            Tallinna Keskkonna- ja Kommunaalamet („meie“) salvestab hhhis.tallinn.ee lehe sirvimisel
                            teie seadmesse küpsiseid.
                            Meie küpsiste poliitika kirjeldab mis küpsised on, kuidas me neid kasutame, kuidas neid
                            võivad kasutada kolmandad osapooled, kellega me koostööd teeme, ning kust leida
                            lisainfot küpsiste kohta.
                        </p>


                        <h2>Mis on küpsised?</h2>
                        <p>
                            Küpsis on väike tekstifail, mille veebileht salvestab teie seadmesse lehe külastamisel.
                            See aitab veebilehel teatud ajaks jätta meelde teie toimingud ja tehtud valikud.
                            Kuidas Tallinna Keskkonna- ja Kommunaalamet kasutab küpsiseid?
                            hhhis.tallinn.ee lehte kasutades salvestame teie veebibrauserisse küpsiste faile.
                            Kasutame küpsiseid järgmistel eesmärkidel: teatud infosüsteemi osade toimimise tarbeks,
                            teie valikute salvestamiseks, veebistatistika kogumiseks, veebi uuringute tegemiseks ja
                            reklaamide kuvamiseks.
                        </p>
                        <h2>Kolmandate osapoolte küpsised</h2>
                        <p>
                            Lisaks meie oma küpsistele, võime kasutada ka kolmandate osapoolte küpsiseid, et koguda
                            veebistatistikat (nt Google Analytics), reklaamide kuvamiseks (Facebook Pixel).
                        </p>
                        <h2>Kuidas küpsiseid kontrollida?</h2>
                        <p>
                            Võite küpsiseid kontrollida ja/või kustutada vastavalt oma soovile. Võite kustutada kõik
                            juba teie arvutis olevad küpsised ning enamik brausereid on võimalik seadistada
                            selliselt, et küpsiste paigaldamine oleks tõkestatud. Sellisel juhul võite olla sunnitud
                            iga kord lehe külastamisel tegema teatavaid valikuid ning mõned teenused ja funktsioonid
                            ei pruugi toimida.
                        </p>
                        <h2>Kust leida lisainfot küpsiste kohta?</h2>
                        <p>
                            Küpsiste kohta leiab lisainfot lehelt The EU Internet Handbook:
                            {' '}
                            <a href="http://ec.europa.eu" target="_blank" rel="noopener noreferrer">http://ec.europa.eu</a>
                        </p>
                    </div>
                </div>
            </Fragment>
        );
    }
}
